import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"

import '@/pages/profile/sections/common.css'

export default function Email(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.email}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }
            <InputBox
                id={listOfSections.email}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.email)}
                value={props.value}
                placeholder={profile.placeHolders.enterEmail}
                showAsterisk={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.email)}
                />
            </div>
        </div>
    );
}
